import { render, staticRenderFns } from "./ParametreAccount.vue?vue&type=template&id=0e5b6bb8"
import script from "./ParametreAccount.vue?vue&type=script&lang=js"
export * from "./ParametreAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports